module.exports = __webpack_public_path__ + "static/media/sun-loan-logo-2.c0239df7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/sun-loan-logo-2.svg
// module id = 813
// module chunks = 1